import { render } from "./Gallery.vue?vue&type=template&id=7f33b6af&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=7f33b6af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f33b6af"

export default script